export default {
  api: {
    internal: {
      events: () => '/!api/internal/analytics/events',
    },
  },
};
